import TippingContactUsView from './ContactUs';
import TippingFAQsView from './FAQs';
import GameGuidelinesView from './GameGuidelines';
import TippingPrizesView from './Prizes';
import TippingTermsAndConditionsView from './TermsAndConditions';
import TippingWhatsNewView from './WhatsNew';

export {
	TippingContactUsView,
	TippingFAQsView,
	GameGuidelinesView,
	TippingPrizesView,
	TippingTermsAndConditionsView,
	TippingWhatsNewView
};

export default {
	TippingContactUsView,
	TippingFAQsView,
	GameGuidelinesView,
	TippingPrizesView,
	TippingTermsAndConditionsView,
	TippingWhatsNewView
}